<template>
    <section class="sk-home__section sk-home__section--skeleton sk-home__delivery-care--skeleton">
        <div class="sk-home__container">
            <div class="delivery-care__items">
            </div>
        </div>
    </section>
</template>